import RbDataTable from "@/shared/components/table/RbDataTable.vue";
import RbInformationCard from "@/shared/components/cards/RbInformationCard.vue";
import RbActionToolbar from "@/shared/components/toolbar/RbActionToolbar.vue";
import RbTitleToolbar from "@/shared/components/toolbar/RbTitleToolbar.vue";
import RbDialogToolbar from "@/shared/components/toolbar/RbDialogToolbar.vue";
import RbMidScreenDialog from "@/shared/components/RbMidScreenDialog.vue";
import RbTopBar from "@/shared/components/RbTopBar.vue";
import RbSidebar from "@/shared/components/sidebar/RbSidebar.vue";
import RbTextField from "@/shared/components/atoms/RbTextField.vue";
import RbSelect from "@/shared/components/atoms/RbSelect.vue";
import RbNavigationDrawer from "@/shared/components/atoms/RbNavigationDrawer.vue";
import RbTextArea from "@/shared/components/atoms/RbTextArea.vue";
import SectionHeader from "@/shared/components/header/SectionHeader.vue";

const components = {
  "rb-data-table": RbDataTable,
  "rb-infomation-card": RbInformationCard,
  "rb-action-toolbar": RbActionToolbar,
  "rb-title-toolbar": RbTitleToolbar,
  "rb-dialog-toolbar": RbDialogToolbar,
  "rb-midscreen-dialog": RbMidScreenDialog,
  "rb-topbar": RbTopBar,
  "rb-sidebar": RbSidebar,
  "rb-text-field": RbTextField,
  "rb-text-area": RbTextArea,
  "rb-select": RbSelect,
  "rb-navigation-drawer": RbNavigationDrawer,
  "section-header": SectionHeader,
};

export default function registerGlobalComponents(app) {
  Object.entries(components).forEach(([name, component]) => {
    app.component(name, component);
  });
}
